import * as Scrivito from "scrivito"

export const TestimonialWidget = Scrivito.provideWidgetClass(
  "TestimonialWidget",
  {
    attributes: {
      testimony: "string",
      testimonyLong: "string",
      image: ["reference", { only: "Image" }],
      imageWidgets: ["widgetlist", { only: "ImageWidget" }],
      author: "string",
      authorPosition: "string",
      authorAffiliation: "string",
      alternativeBackground: "boolean"
    }
  }
)
